export const REEL_LIST_ATTEMPT = 'REEL_LIST_ATTEMPT';
export const REEL_LIST_SUCCESS = 'REEL_LIST_SUCCESS';
export const REEL_LIST_FAILED = 'REEL_LIST_FAILED';
export const REEL_DELETE_SUCCESS = 'REEL_DELETE_SUCCESS';
